import { useState } from "react";

import { CheckIcon, CopyIcon } from "~/components/disarto-icons";
import { Button } from "~/components/ui/button";
import { useCopyToClipboard } from "~/hooks/useCopyToClipboard";

export function CopyBlock({
  value,
  label = "text",
  className,
}: {
  readonly value: string;
  readonly label?: string;
  readonly className?: string;
}) {
  const [error, setError] = useState<string>();
  const { copyToClipboard, isCopied } = useCopyToClipboard({
    target: label,
    onError: () => setError("Couldn't copy. Select the text and copy it manually."),
    onCopy: () => setError(undefined),
  });

  return (
    <div className={className} role="group" aria-label={label}>
      <div className="flex items-center gap-2 rounded-md bg-muted p-3">
        <pre className="min-w-0 flex-1 overflow-auto select-text">
          <code>{value}</code>
        </pre>
        <Button
          aria-label={isCopied ? "Copied" : `Copy ${label}`}
          onClick={() => copyToClipboard(value)}
          size="icon-sm"
          tooltip={isCopied ? "Copied" : "Copy"}
          type="button"
          variant="ghost"
        >
          {isCopied ? <CheckIcon className="size-4" /> : <CopyIcon className="size-4" />}
        </Button>
      </div>
      {error === undefined ? null : (
        <p className="mt-1 text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
